// Facebook signed CDN URLs (e.g. platform-lookaside.fbsbx.com) embed a unix-timestamp `ext=` query
// that marks expiry. Skip rendering when the timestamp is in the past so the browser never fetches
// a known-expired image.
export const isExpiredCdnUrl = (url?: string | null): boolean => {
  if (!url) return false;
  try {
    const ext = new URL(url).searchParams.get('ext');
    if (!ext) return false;
    const expiryMs = Number(ext) * 1000;
    return Number.isFinite(expiryMs) && Date.now() > expiryMs;
  } catch {
    return false;
  }
};
